import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  urlBase: any;

  constructor(private http: HttpClient) {
    this.urlBase = `${environment.bffBaseUrl}/api/country`;
  }

    getAll(): Observable<Array<any>> {
    let urlCountry = `${this.urlBase}`;
    return this.http.get<Array<any>>(urlCountry);
  }

}

